import type { ThemeCollection } from '../types/theme.types';

// Orb-focused themes designed specifically for floating circular gradients
// Optimized for AI chatbots and voice assistants with higher contrast and glow effects
export const ORB_THEMES: ThemeCollection = {
  // DARK ORB THEMES (5)
  
  cyberpunk: {
    backgroundColor: '#0a0a0a',
    visualEffects: {
      saturation: 1.5,
      contrast: 1.5,
      brightness: 1.0,
      hue: 0,
    },
    lighting3d: {
      enabled: true,
      position: { x: 30, y: 30 },
      intensity: 0.75,
    },
    dropShadow: {
      enabled: true,
      size: 20,
      opacity: 0.15,
      direction: { x: 0, y: -3 },
    },
    shapes: [
      {
        id: 'cyberpunk-1',
        width: 80,
        height: 80,
        x: -20,
        y: -20,
        gradient: 'radial-gradient(circle, #00ff88 0%, #00cc44 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 1,
      },
      {
        id: 'cyberpunk-2',
        width: 80,
        height: 80,
        x: 40,
        y: -20,
        gradient: 'radial-gradient(circle, #ff0080 0%, #cc0060 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 2,
      },
      {
        id: 'cyberpunk-3',
        width: 80,
        height: 80,
        x: -20,
        y: 40,
        gradient: 'radial-gradient(circle, #0080ff 0%, #0060cc 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 3,
      },
      {
        id: 'cyberpunk-4',
        width: 80,
        height: 80,
        x: 40,
        y: 40,
        gradient: 'radial-gradient(circle, #ffff00 0%, #cccc00 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 4,
      },
    ],
  },

  voidPulse: {
    backgroundColor: '#000000',
    visualEffects: {
      saturation: 1.5,
      contrast: 1.5,
      brightness: 1.0,
      hue: 0,
    },
    lighting3d: {
      enabled: true,
      position: { x: 30, y: 30 },
      intensity: 0.75,
    },
    dropShadow: {
      enabled: true,
      size: 20,
      opacity: 0.15,
      direction: { x: 0, y: -3 },
    },
    shapes: [
      {
        id: 'void-1',
        width: 80,
        height: 80,
        x: -20,
        y: -20,
        gradient: 'radial-gradient(circle, #6a0dad 0%, #4b0082 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 1,
      },
      {
        id: 'void-2',
        width: 80,
        height: 80,
        x: 40,
        y: -20,
        gradient: 'radial-gradient(circle, #8a2be2 0%, #6a0dad 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 2,
      },
      {
        id: 'void-3',
        width: 80,
        height: 80,
        x: -20,
        y: 40,
        gradient: 'radial-gradient(circle, #000080 0%, #000040 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 3,
      },
      {
        id: 'void-4',
        width: 80,
        height: 80,
        x: 40,
        y: 40,
        gradient: 'radial-gradient(circle, #4b0082 0%, #2d1b69 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 4,
      },
    ],
  },

  fireCore: {
    backgroundColor: '#1a0f0a',
    visualEffects: {
      saturation: 1.5,
      contrast: 1.5,
      brightness: 1.0,
      hue: 0,
    },
    lighting3d: {
      enabled: true,
      position: { x: 30, y: 30 },
      intensity: 0.75,
    },
    dropShadow: {
      enabled: true,
      size: 20,
      opacity: 0.15,
      direction: { x: 0, y: -3 },
    },
    shapes: [
      {
        id: 'fire-1',
        width: 80,
        height: 80,
        x: -20,
        y: -20,
        gradient: 'radial-gradient(circle, #ff6b35 0%, #f7931e 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 1,
      },
      {
        id: 'fire-2',
        width: 80,
        height: 80,
        x: 40,
        y: -20,
        gradient: 'radial-gradient(circle, #ffa502 0%, #ff6348 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 2,
      },
      {
        id: 'fire-3',
        width: 80,
        height: 80,
        x: -20,
        y: 40,
        gradient: 'radial-gradient(circle, #ffdd59 0%, #ffa502 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 3,
      },
      {
        id: 'fire-4',
        width: 80,
        height: 80,
        x: 40,
        y: 40,
        gradient: 'radial-gradient(circle, #ff4757 0%, #c44569 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 4,
      },
    ],
  },

  deepSpace: {
    backgroundColor: '#0c0c1e',
    visualEffects: {
      saturation: 1.5,
      contrast: 1.5,
      brightness: 1.0,
      hue: 0,
    },
    lighting3d: {
      enabled: true,
      position: { x: 30, y: 30 },
      intensity: 0.75,
    },
    dropShadow: {
      enabled: true,
      size: 20,
      opacity: 0.15,
      direction: { x: 0, y: -3 },
    },
    shapes: [
      {
        id: 'space-1',
        width: 80,
        height: 80,
        x: -20,
        y: -20,
        gradient: 'radial-gradient(circle, #00d4ff 0%, #0078d4 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 1,
      },
      {
        id: 'space-2',
        width: 80,
        height: 80,
        x: 40,
        y: -20,
        gradient: 'radial-gradient(circle, #805ad5 0%, #553c9a 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 2,
      },
      {
        id: 'space-3',
        width: 80,
        height: 80,
        x: -20,
        y: 40,
        gradient: 'radial-gradient(circle, #38b2ac 0%, #319795 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 3,
      },
      {
        id: 'space-4',
        width: 80,
        height: 80,
        x: 40,
        y: 40,
        gradient: 'radial-gradient(circle, #5a67d8 0%, #2d3748 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 4,
      },
    ],
  },

  shadowGlow: {
    backgroundColor: '#1a1a1a',
    visualEffects: {
      saturation: 1.5,
      contrast: 1.5,
      brightness: 1.0,
      hue: 0,
    },
    lighting3d: {
      enabled: true,
      position: { x: 30, y: 30 },
      intensity: 0.75,
    },
    dropShadow: {
      enabled: true,
      size: 20,
      opacity: 0.15,
      direction: { x: 0, y: -3 },
    },
    shapes: [
      {
        id: 'shadow-1',
        width: 80,
        height: 80,
        x: -20,
        y: -20,
        gradient: 'radial-gradient(circle, #a78bfa 0%, #8b5cf6 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 1,
      },
      {
        id: 'shadow-2',
        width: 80,
        height: 80,
        x: 40,
        y: -20,
        gradient: 'radial-gradient(circle, #f472b6 0%, #ec4899 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 2,
      },
      {
        id: 'shadow-3',
        width: 80,
        height: 80,
        x: -20,
        y: 40,
        gradient: 'radial-gradient(circle, #7c3aed 0%, #5b21b6 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 3,
      },
      {
        id: 'shadow-4',
        width: 80,
        height: 80,
        x: 40,
        y: 40,
        gradient: 'radial-gradient(circle, #be185d 0%, #831843 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 4,
      },
    ],
  },

  // LIGHT ORB THEMES (5)

  crystalBlue: {
    backgroundColor: '#f0f8ff',
    visualEffects: {
      saturation: 1.5,
      contrast: 1.5,
      brightness: 1.0,
      hue: 0,
    },
    lighting3d: {
      enabled: true,
      position: { x: 30, y: 30 },
      intensity: 0.75,
    },
    dropShadow: {
      enabled: true,
      size: 20,
      opacity: 0.15,
      direction: { x: 0, y: -3 },
    },
    shapes: [
      {
        id: 'crystal-1',
        width: 80,
        height: 80,
        x: -20,
        y: -20,
        gradient: 'radial-gradient(circle, #3b82f6 0%, #2563eb 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 1,
      },
      {
        id: 'crystal-2',
        width: 80,
        height: 80,
        x: 40,
        y: -20,
        gradient: 'radial-gradient(circle, #0ea5e9 0%, #0284c7 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 2,
      },
      {
        id: 'crystal-3',
        width: 80,
        height: 80,
        x: -20,
        y: 40,
        gradient: 'radial-gradient(circle, #22c55e 0%, #16a34a 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 3,
      },
      {
        id: 'crystal-4',
        width: 80,
        height: 80,
        x: 40,
        y: 40,
        gradient: 'radial-gradient(circle, #1d4ed8 0%, #1e40af 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 4,
      },
    ],
  },

  sunbeam: {
    backgroundColor: '#fffbf0',
    visualEffects: {
      saturation: 1.5,
      contrast: 1.5,
      brightness: 1.0,
      hue: 0,
    },
    lighting3d: {
      enabled: true,
      position: { x: 30, y: 30 },
      intensity: 0.75,
    },
    dropShadow: {
      enabled: true,
      size: 20,
      opacity: 0.15,
      direction: { x: 0, y: -3 },
    },
    shapes: [
      {
        id: 'sun-1',
        width: 80,
        height: 80,
        x: -20,
        y: -20,
        gradient: 'radial-gradient(circle, #fbbf24 0%, #f59e0b 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 1,
      },
      {
        id: 'sun-2',
        width: 80,
        height: 80,
        x: 40,
        y: -20,
        gradient: 'radial-gradient(circle, #fcd34d 0%, #fbbf24 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 2,
      },
      {
        id: 'sun-3',
        width: 80,
        height: 80,
        x: -20,
        y: 40,
        gradient: 'radial-gradient(circle, #f87171 0%, #ef4444 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 3,
      },
      {
        id: 'sun-4',
        width: 80,
        height: 80,
        x: 40,
        y: 40,
        gradient: 'radial-gradient(circle, #d97706 0%, #dc2626 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 4,
      },
    ],
  },

  roseDawn: {
    backgroundColor: '#fdf2f8',
    visualEffects: {
      saturation: 1.5,
      contrast: 1.5,
      brightness: 1.0,
      hue: 0,
    },
    lighting3d: {
      enabled: true,
      position: { x: 30, y: 30 },
      intensity: 0.75,
    },
    dropShadow: {
      enabled: true,
      size: 20,
      opacity: 0.15,
      direction: { x: 0, y: -3 },
    },
    shapes: [
      {
        id: 'rose-1',
        width: 80,
        height: 80,
        x: -20,
        y: -20,
        gradient: 'radial-gradient(circle, #f472b6 0%, #ec4899 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 1,
      },
      {
        id: 'rose-2',
        width: 80,
        height: 80,
        x: 40,
        y: -20,
        gradient: 'radial-gradient(circle, #c4b5fd 0%, #a78bfa 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 2,
      },
      {
        id: 'rose-3',
        width: 80,
        height: 80,
        x: -20,
        y: 40,
        gradient: 'radial-gradient(circle, #fbcfe8 0%, #f472b6 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 3,
      },
      {
        id: 'rose-4',
        width: 80,
        height: 80,
        x: 40,
        y: 40,
        gradient: 'radial-gradient(circle, #db2777 0%, #8b5cf6 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 4,
      },
    ],
  },

  mintFresh: {
    backgroundColor: '#f0fdf4',
    visualEffects: {
      saturation: 1.5,
      contrast: 1.5,
      brightness: 1.0,
      hue: 0,
    },
    lighting3d: {
      enabled: true,
      position: { x: 30, y: 30 },
      intensity: 0.75,
    },
    dropShadow: {
      enabled: true,
      size: 20,
      opacity: 0.15,
      direction: { x: 0, y: -3 },
    },
    shapes: [
      {
        id: 'mint-1',
        width: 80,
        height: 80,
        x: -20,
        y: -20,
        gradient: 'radial-gradient(circle, #34d399 0%, #10b981 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 1,
      },
      {
        id: 'mint-2',
        width: 80,
        height: 80,
        x: 40,
        y: -20,
        gradient: 'radial-gradient(circle, #22c55e 0%, #16a34a 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 2,
      },
      {
        id: 'mint-3',
        width: 80,
        height: 80,
        x: -20,
        y: 40,
        gradient: 'radial-gradient(circle, #86efac 0%, #4ade80 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 3,
      },
      {
        id: 'mint-4',
        width: 80,
        height: 80,
        x: 40,
        y: 40,
        gradient: 'radial-gradient(circle, #059669 0%, #15803d 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 4,
      },
    ],
  },

  lavenderMist: {
    backgroundColor: '#faf5ff',
    visualEffects: {
      saturation: 1.5,
      contrast: 1.5,
      brightness: 1.0,
      hue: 0,
    },
    lighting3d: {
      enabled: true,
      position: { x: 30, y: 30 },
      intensity: 0.75,
    },
    dropShadow: {
      enabled: true,
      size: 20,
      opacity: 0.15,
      direction: { x: 0, y: -3 },
    },
    shapes: [
      {
        id: 'lavender-1',
        width: 80,
        height: 80,
        x: -20,
        y: -20,
        gradient: 'radial-gradient(circle, #c4b5fd 0%, #a78bfa 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 1,
      },
      {
        id: 'lavender-2',
        width: 80,
        height: 80,
        x: 40,
        y: -20,
        gradient: 'radial-gradient(circle, #ddd6fe 0%, #c4b5fd 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 2,
      },
      {
        id: 'lavender-3',
        width: 80,
        height: 80,
        x: -20,
        y: 40,
        gradient: 'radial-gradient(circle, #a5b4fc 0%, #818cf8 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 3,
      },
      {
        id: 'lavender-4',
        width: 80,
        height: 80,
        x: 40,
        y: 40,
        gradient: 'radial-gradient(circle, #8b5cf6 0%, #6366f1 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 4,
      },
    ],
  },

  // NEW PREMIUM ORB THEMES - Enhanced Sunset Variations

  sunsetGlow: {
    backgroundColor: '#1a0f0a',
    visualEffects: {
      saturation: 3,
      contrast: 2,
      brightness: 2,
      hue: 0,
    },
    lighting3d: {
      enabled: true,
      position: { x: 75, y: 15 },
      intensity: 0.85,
    },
    dropShadow: {
      enabled: true,
      size: 20,
      opacity: 0.15,
      direction: { x: 0, y: -3 },
    },
    shapes: [
      {
        id: 'sunset-glow-1',
        width: 85,
        height: 85,
        x: -22,
        y: -22,
        gradient: 'radial-gradient(circle, #ff6b35 0%, #f7931e 30%, #ff4757 70%, #c44569 100%)',
        blur: 15,
        opacity: 0.9,
        zIndex: 1,
      },
      {
        id: 'sunset-glow-2',
        width: 80,
        height: 80,
        x: 40,
        y: -20,
        gradient: 'radial-gradient(circle, #ffa502 0%, #ff6348 50%, #ff4757 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 2,
      },
      {
        id: 'sunset-glow-3',
        width: 80,
        height: 80,
        x: -20,
        y: 40,
        gradient: 'radial-gradient(circle, #ffdd59 0%, #ffa502 60%, #ff6b35 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 3,
      },
      {
        id: 'sunset-glow-4',
        width: 85,
        height: 85,
        x: 37,
        y: 37,
        gradient: 'radial-gradient(circle, #ff4757 0%, #c44569 40%, #8b5cf6 80%, #6a0dad 100%)',
        blur: 15,
        opacity: 0.9,
        zIndex: 4,
      },
    ],
  },

  dawnLight: {
    backgroundColor: '#fef3f2',
    visualEffects: {
      saturation: 2.5,
      contrast: 1.8,
      brightness: 1.8,
      hue: 10,
    },
    lighting3d: {
      enabled: true,
      position: { x: 70, y: 20 },
      intensity: 0.75,
    },
    dropShadow: {
      enabled: true,
      size: 20,
      opacity: 0.15,
      direction: { x: 0, y: -3 },
    },
    shapes: [
      {
        id: 'dawn-1',
        width: 85,
        height: 85,
        x: -22,
        y: -22,
        gradient: 'radial-gradient(circle, #fbbf24 0%, #f59e0b 30%, #f97316 70%, #ea580c 100%)',
        blur: 15,
        opacity: 0.8,
        zIndex: 1,
      },
      {
        id: 'dawn-2',
        width: 80,
        height: 80,
        x: 40,
        y: -20,
        gradient: 'radial-gradient(circle, #fed7aa 0%, #fdba74 50%, #fb923c 100%)',
        blur: 12,
        opacity: 0.75,
        zIndex: 2,
      },
      {
        id: 'dawn-3',
        width: 80,
        height: 80,
        x: -20,
        y: 40,
        gradient: 'radial-gradient(circle, #fef3c7 0%, #fde68a 60%, #fbbf24 100%)',
        blur: 12,
        opacity: 0.75,
        zIndex: 3,
      },
      {
        id: 'dawn-4',
        width: 85,
        height: 85,
        x: 37,
        y: 37,
        gradient: 'radial-gradient(circle, #f97316 0%, #ea580c 40%, #dc2626 80%, #b91c1c 100%)',
        blur: 15,
        opacity: 0.8,
        zIndex: 4,
      },
    ],
  },

  twilightDark: {
    backgroundColor: '#0c0513',
    visualEffects: {
      saturation: 3.2,
      contrast: 2.2,
      brightness: 1.9,
      hue: -5,
    },
    lighting3d: {
      enabled: true,
      position: { x: 80, y: 10 },
      intensity: 0.9,
    },
    dropShadow: {
      enabled: true,
      size: 20,
      opacity: 0.15,
      direction: { x: 0, y: -3 },
    },
    shapes: [
      {
        id: 'twilight-1',
        width: 85,
        height: 85,
        x: -22,
        y: -22,
        gradient: 'radial-gradient(circle, #4c1d95 0%, #6b21a8 30%, #7c3aed 70%, #8b5cf6 100%)',
        blur: 15,
        opacity: 0.9,
        zIndex: 1,
      },
      {
        id: 'twilight-2',
        width: 80,
        height: 80,
        x: 40,
        y: -20,
        gradient: 'radial-gradient(circle, #1e1b4b 0%, #312e81 50%, #4338ca 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 2,
      },
      {
        id: 'twilight-3',
        width: 80,
        height: 80,
        x: -20,
        y: 40,
        gradient: 'radial-gradient(circle, #7c2d12 0%, #9a3412 60%, #dc2626 100%)',
        blur: 12,
        opacity: 0.85,
        zIndex: 3,
      },
      {
        id: 'twilight-4',
        width: 85,
        height: 85,
        x: 37,
        y: 37,
        gradient: 'radial-gradient(circle, #831843 0%, #be185d 40%, #e11d48 80%, #f43f5e 100%)',
        blur: 15,
        opacity: 0.9,
        zIndex: 4,
      },
    ],
  },

  midnightGlow: {
    backgroundColor: '#000000',
    visualEffects: {
      saturation: 3.5,
      contrast: 2.5,
      brightness: 2.2,
      hue: 0,
    },
    lighting3d: {
      enabled: true,
      position: { x: 85, y: 5 },
      intensity: 1.0,
    },
    dropShadow: {
      enabled: true,
      size: 20,
      opacity: 0.15,
      direction: { x: 0, y: -3 },
    },
    shapes: [
      {
        id: 'midnight-1',
        width: 85,
        height: 85,
        x: -22,
        y: -22,
        gradient: 'radial-gradient(circle, #0ea5e9 0%, #0284c7 30%, #0369a1 70%, #075985 100%)',
        blur: 15,
        opacity: 0.95,
        zIndex: 1,
      },
      {
        id: 'midnight-2',
        width: 80,
        height: 80,
        x: 40,
        y: -20,
        gradient: 'radial-gradient(circle, #06b6d4 0%, #0891b2 50%, #0e7490 100%)',
        blur: 12,
        opacity: 0.9,
        zIndex: 2,
      },
      {
        id: 'midnight-3',
        width: 80,
        height: 80,
        x: -20,
        y: 40,
        gradient: 'radial-gradient(circle, #10b981 0%, #059669 60%, #047857 100%)',
        blur: 12,
        opacity: 0.9,
        zIndex: 3,
      },
      {
        id: 'midnight-4',
        width: 85,
        height: 85,
        x: 37,
        y: 37,
        gradient: 'radial-gradient(circle, #6366f1 0%, #4f46e5 40%, #4338ca 80%, #3730a3 100%)',
        blur: 15,
        opacity: 0.95,
        zIndex: 4,
      },
    ],
  },
}; 